import Zoom from "./zoom";

export default Zoom;